import React, { useState } from 'react';
import Grid from "@mui/material/Grid2";

import { 
  Character, 
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import NotesButton from '@components/input/buttons/NotesButton';
import CharacterNotes from "@dndComponents/character/misc/CharacterNotes";
import CharacterDescription from "@dndComponents/character/misc/CharacterDescription";
import CenteredMenu from '@components/input/menus/CenteredMenu';

interface Props {
  char: Character;
}

export default function CharacterNotesButton({
  char,
}: Props) {
  const [open, setOpen] = useState(false);
  const [ping, setPing] = useState(false);
  const [tab, setTab] = useState("Notes");

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open ?
          <>
            <Grid container spacing={0} direction="row">
              <Grid size={12}>
                <CenteredMenu
                  options={["Notes","Description"]}
                  selected={tab}
                  onSelect={setTab}
                />
              </Grid>
              <Grid size={12}>
                { tab === "Notes" ?
                  <CharacterNotes
                    character={char}
                  />
                :
                  <CharacterDescription
                    character={char}
                  />
                }
              </Grid>
            </Grid>
          </>
          : <></>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <NotesButton
        onClick={() => { setOpen(true); }}
      />
      { renderExtras() }
    </>
  ); 
}

